export const Constants = {
  OrderStatuses: {
    PENDING: 'Pending',
    COMPLETED: 'Completed',
    PROCESSING: 'Procesing',
    SHIPPED: 'Shipped',
    REJECTED: 'Rejected'
  },

  categoryTrans: {
    description: 'Description',
    thread_size: 'Thread Size',
    color: 'Color',
    lug_nut_length: 'Lug Nut Length',
    lug_nut_diameter: 'Lug Nut Diameter',
    thread_length: 'Thread Length',
    lug_bolt_diameter: 'Lug Bolt Diameter',
    ext_center_bore: 'Ext. Center Bore',
    center_bore: 'Center Bore',
    bolt_pattern: 'Bolt Pattern',
    width: 'Width',
  }
}
